export default "__VITE_ASSET__SLUUg_EL__"